
import { Icon } from '@mui/material';
import C2PAImg from '../../../assets/cr.svg';
const C2PA = (props) => {
  return (
    <div {...props}>
      <Icon>
        <img src={C2PAImg} alt=".." />
      </Icon>
    </div>
  );
};

export default C2PA;